"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logsumUnits = void 0;
const logsumUnits = exports.logsumUnits = ['perc_retransmits_in', 'perc_retransmits_out', 'perc_repeated_retransmits', 'perc_out_of_order_in', 'perc_out_of_order_out', 'perc_fragments', 'perc_zero_windows', 'client_latency', 'server_latency', 'appl_latency', 'fpex_latency', 'receive_window'];